import React, { useState } from 'react';
import { MetaTags } from 'react-meta-tags';
//import Breadcrumbs
import { DashBreadcrumb } from '../../components/Common/Breadcrumb';
import 'react-drawer/lib/react-drawer.css';
import { Col, Container, Row, Spinner } from 'reactstrap';
import { Toaster } from 'react-hot-toast';
import ManagePurifierOrdersList from './components/ManagePurifierOrdersList';
import PurifierCreateOffcanvas from './components/PurifierCreateOffcanvas';

const ManagePurifierOrders = () => {
  const users = JSON.parse(localStorage?.getItem('authUser'));

  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState();
  const [refreshList, setRefreshList] = useState(false);
  const [showCreatePurifier, setShowCreatePurifier] = useState(false);

  const toggleCreatePurifier = () => setShowCreatePurifier((prev) => !prev);
  const handlePurifierCreated = () => setRefreshList((prev) => !prev);

  return (
    <React.Fragment>
      {loading ? (
        <div className="loader-container">
          <Spinner type="grow" className="ms-2" color="dark" />
        </div>
      ) : (
        <></>
      )}
      <div className="page-content refundOrder">
        <MetaTags>
          <title>Manage Purifier Orders</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row className="align-items-center">
            <Col xl={4}>
              <DashBreadcrumb
                title="Purifier Orders"
                breadcrumbItem="Manage Purifier Orders List"
              />
            </Col>
            <Col xl={8}>
              <div className="d-flex justify-content-end align-items-center mb-3">
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={toggleCreatePurifier}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <i className="mdi mdi-plus-circle-outline me-1"></i>
                  Create Purifier Order
                </button>
              </div>
            </Col>
          </Row>
          <ManagePurifierOrdersList stores={stores} refreshList={refreshList} />
          <PurifierCreateOffcanvas
            isOpen={showCreatePurifier}
            toggle={toggleCreatePurifier}
            onCreated={handlePurifierCreated}
          />
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default ManagePurifierOrders;
